import chroma from 'chroma-js';
/**
 * Generates a hex color based on a gradient scale from white to the base color.
 * @param baseColor - The highest value color in hex format.
 * @param value - The current numeric value.
 * @param min - The minimum possible value.
 * @param max - The maximum possible value.
 * @returns A hex string representing the interpolated color.
 */
export const getGradientColor = (
  baseColor: string,
  value: number,
  min: number,
  max: number
): string => {
  if (value <= min) return '#FFFFFF'; // Lowest value is white
  if (value >= max) return baseColor; // Highest value is baseColor

  // Normalize value between 0 and 1
  const normalizedScaleValue = (value - min) / (max - min);

  // Interpolate between white and base color
  return chroma.scale(['#FFFFFF', baseColor])(normalizedScaleValue).hex();
};
